// This file ensures webpack runtime is properly initialized
// and vendor chunks are loaded before other webpack modules

// This will be loaded as part of the vendor chunks
// and ensures proper webpack runtime coordination

if (typeof window !== 'undefined') {
  // Ensure webpackChunktalentadore_searchform array exists
  window.webpackChunktalentadore_searchform = window.webpackChunktalentadore_searchform || [];
  
  // Check for webpack runtime availability and log initialization status
  if (window.__webpack_require__) {
    // Webpack runtime is available
    console.log('Webpack runtime initialized');
  }
}